import React from 'react';
import {Button} from 'iss/widgets/Buttons';
import ajax from '../utils/ajax';

function openBlob(path, type, anchor) {
  ajax.getBlob(path, {headers: {'Accept': type}})
    .subscribe(response => {
      const url = URL.createObjectURL(response.blob);

      // Since no filename can be specified for the URL or as a parameter to window.open(),
      // use an (hidden) anchor element that is then clicked after defining href.
      // This way when the browser prompts to save a file, the correct filename is suggested
      // instead of a random looking name based on the URL. Also, in some cases the user
      // might not be able to enter a filename in the save dialog.
      // If no filename is defined in the response or in the anchor element, just use open()
      // - it works e.g. in case of PDFs that are opened in the browser directly.
      if (anchor && (response.filename || anchor.download)) {
        anchor.href = url;
        anchor.download = response.filename;
        anchor.click();
      } else {
        window.open(url);
      }
    });
}

export function DownloadBlobButton({text, url, type, filename, ...props}) {
  let anchor = undefined;

  return (
    <div>
      <Button onClick={() => openBlob(url, type, anchor)} {...props}>
        {text}
      </Button>
      <a target='_blank' ref={e => anchor = e} download={filename} />
    </div>
  );
}

export function DownloadPdfButton({text, url, ...props}) {
  return <DownloadBlobButton text={text} url={url} type='application/pdf' className="pdf-report" {...props}/>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/DownloadBlobButton.jsx